// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  min-height: calc(100vh - 152px);
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/MainLayout/styles.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,WAAW;AACb","sourcesContent":[".content {\n  min-height: calc(100vh - 152px);\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
